const nl = "nl-NL";

export const NA = "Niet beschikbaar";

export function eur(value, { decimals = 0, fallback = NA } = {}) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return fallback;
  return `€ ${Number(value).toLocaleString(nl, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
}

export function eurSigned(value, { fallback = NA } = {}) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return fallback;
  const sign = Number(value) > 0 ? "+" : Number(value) < 0 ? "−" : "";
  return `${sign}${eur(Math.abs(Number(value)))}`;
}

export function pct(value, { decimals = 1, fallback = NA } = {}) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return fallback;
  return `${Number(value).toLocaleString(nl, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}%`;
}

export function num(value, { decimals = 0, fallback = NA } = {}) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return fallback;
  return Number(value).toLocaleString(nl, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function km(value, { fallback = NA } = {}) {
  if (value === null || value === undefined) return fallback;
  return `${num(value)} km`;
}

export function dateTime(value, { fallback = "—" } = {}) {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}`;
}

export function dateOnly(value, { fallback = "—" } = {}) {
  if (!value) return fallback;
  const raw = String(value);
  if (/^\d{4}-\d{2}$/.test(raw)) {
    const [y, m] = raw.split("-");
    return `${m}-${y}`;
  }
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return raw;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()}`;
}

export function regYear(value) {
  if (!value) return "—";
  const raw = String(value);
  return raw.slice(0, 4);
}

export function vehicleTitle(v) {
  if (!v) return "—";
  const model = (v.model || "").trim();
  const variant = (v.variant || "").trim();
  const cleaned =
    model && variant.toLowerCase().startsWith(model.toLowerCase())
      ? variant.slice(model.length).trim()
      : variant;
  return [v.make, model, cleaned].filter(Boolean).join(" ");
}

export function countryName(code) {
  const map = {
    DE: "Duitsland",
    NL: "Nederland",
    BE: "België",
    AT: "Oostenrijk",
    IT: "Italië",
    FR: "Frankrijk",
    ES: "Spanje",
  };
  return map[code] || code || "—";
}

export function vehicleSpec(v = {}) {
  return [v.generation, regYear(v.first_registration), km(v.mileage_km)]
    .filter(Boolean)
    .join(" | ");
}

export function vehicleSpecShort(v = {}) {
  return [regYear(v.first_registration), km(v.mileage_km), countryName(v.country)]
    .filter(Boolean)
    .join(" | ");
}

export const SCORE_STYLES = {
  GREEN: "bg-emerald-100 text-emerald-800 border-emerald-300",
  ORANGE: "bg-amber-100 text-amber-800 border-amber-300",
  RED: "bg-red-100 text-red-800 border-red-300",
  UNKNOWN: "bg-slate-100 text-slate-600 border-slate-300",
};

export function scoreBand(score) {
  if (score === null || score === undefined) return "UNKNOWN";
  if (score >= 80) return "GREEN";
  if (score >= 60) return "ORANGE";
  return "RED";
}
